import React, { useMemo } from 'react';
import moment from 'moment';
import user from "../../assets/img/usermiddle.png";
import '../../assets/css/message.css';
import {REACT_APP_API_URL} from "../../config.js";

const Message = ({ data, isMine }) => {

    const getEmployee = (data) => {
        return data.client || data.manager || data.accountant;
    };

    const raiseInvoiceClicked = (url) => {
        localStorage.setItem("pageData", "Data Retrieved from axios request");
        window.open(url, "_blank");
    };

    const fileName = (file) => {
        let nameList = file ? file.split("/") : [];
        return nameList[nameList.length - 1];
    };

    return (
        <div>
            <div className="conversation-info"/>
            <div className={['conversation-list-item', isMine ? 'my-message' : ''].join(' ')}>
                <div className='created_date'>{moment(data.created_date).format('lll')}</div>
                <h1 className="conversation-title">{data.sender.first_name} {data.sender.last_name}</h1>
                <div className='photo-name'>
                    <img
                        className="conversation-photo"
                        src={user}
                        alt="img"
                    />
                    <div className={['message', isMine ? 'mine' : ''].join(' ')}>
                        <div className="bubble-container">
                            {data.text && (
                                <div style={{justifyContent:isMine?"end":"start",alignSelf:isMine?"end":"normal",width:"fit-content"}} className="bubble d-flex">{data.text}</div>
                            )}
                            {data.image && (data.image.includes(".jpg") || data.image.includes(".jpeg") || data.image.includes(".png")) ? (
                                <div
                                    className="sms-img"
                                    onClick={() => raiseInvoiceClicked(REACT_APP_API_URL.replace("/api/",'') + data.image)}
                                    style={{ backgroundImage: `url(${REACT_APP_API_URL.replace("/api/",'') + data.image})` }}
                                />
                            ) : data.image ? (
                                <div onClick={() => raiseInvoiceClicked(data.image)}>
                                    {data.file_name || fileName(data.image)}
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>

            <div className={['message', isMine ? 'mine' : ''].join(' ')}>
                <div className="bubble-container"/>
            </div>
        </div>
    );
};

export default Message;
